/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Section } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { TOP_CITIES } from '../constants';

import CityCarousel from './CityCarousel';

// styles
import './CitiesShowcase.scss';
import { CarouselArrows } from './MultipleItemsCarousel';
import CityList from './CityList';

const NUMBER_OF_ITEM_PER_SWIPE_DESKTOP = 4;
const NUMBER_OF_ITEM_PER_SWIPE_MOBILE = 1;
const NUMBER_OF_ITEM_PER_SWIPE_TABLET = 2;

const CitiesShowcase = ({ cityList, deviceType }) => {
  const topCitiesKeys = Object.keys(TOP_CITIES);
  const carouselCities = topCitiesKeys.map(key => {
    return cityList.find(city => city.id === key);
  });

  const listCities = cityList
    .filter(city => !topCitiesKeys.includes(city.id))
    .sort((a, b) => a.cityName.localeCompare(b.cityName));
  const [page, setPage] = useState(0);

  const isDesktop = deviceType === 'desktop';
  const isTablet = deviceType === 'tablet';

  const getNumberOfItems = () => {
    if (isDesktop) {
      return NUMBER_OF_ITEM_PER_SWIPE_DESKTOP;
    } else if (isTablet) {
      return NUMBER_OF_ITEM_PER_SWIPE_TABLET;
    }
    return NUMBER_OF_ITEM_PER_SWIPE_MOBILE;
  };

  return (
    <>
      <Section background="light" className="cities-showcase__top-cities">
        <div className="cities-showcase">
          <div className="cities-showcase__header">
            <h1>{trans('landingpage.label.cities')}</h1>
            <span className="cities-showcase__arrows">
              <CarouselArrows
                page={page}
                setPage={setPage}
                maxPage={Math.round(carouselCities.length / getNumberOfItems())}
              />
            </span>
          </div>
          <div className="cities-showcase__carousel">
            <CityCarousel
              cities={carouselCities}
              page={page}
              numberOfItems={getNumberOfItems()}
            />
          </div>
        </div>
      </Section>
      <Section background="light" className="cities-showcase__other-cities">
        <CityList cities={listCities} numberOfColumns={6} />
      </Section>
    </>
  );
};

CitiesShowcase.propTypes = {
  cityList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ),
  deviceType: PropTypes.string.isRequired
};

CitiesShowcase.defaultProps = {
  cityList: []
};

export default CitiesShowcase;
